module.exports = __webpack_public_path__ + "img/payu.1ded5379.png";